<template>
  <g>
    <g
      v-for="(contourExtent, index) in contourExtents"
      :key="index"
    >
      <visualization-contour
        :key="spot.id"
        :layer-type="layerType"
        :x="contourExtent.extent.x"
        :y="contourExtent.extent.y"
        :width="contourExtent.extent.width"
        :height="contourExtent.extent.height"
        :thingsSpotList="thingsSpotList"
      />
    </g>
  </g>
</template>

<script>
import visualizationContour from '@/components/map/visualization/partials/contours.vue';

export default {
  components: {
    visualizationContour,
  },
  props: {
    spot: { type: Object, default: () => null },
    layerType: { type: String, required: true },
  },
  computed: {
    targetList:   ({ $store, layerType }) => $store.state.visualization.layers[layerType].targetList,
    thingsSpotList() {
      let things = this.spot.things || [];
      return this.targetList.filter((target) => things.some((thing) => thing.id === target.id));
    },
    contourExtents() {
      const list = [];
      const spot = this.spot;
      if (!spot.spotExtents) return list;

      spot.spotExtents.forEach((spotExtent) => {
        const x = (spot.positionX + spotExtent.positionX - (spotExtent.sizeX / 2));
        const y = (spot.positionY + spotExtent.positionY - (spotExtent.sizeY / 2));
        const width  = +spotExtent.sizeX;
        const height = +spotExtent.sizeY;

        list.push({
          extent: { x, y, width, height },
        });
      });
      return list;
    },
  },
};
</script>



// WEBPACK FOOTER //
// contours_spot.vue?d505ddc0